const prefix = 'CUSTOMER_';

export const GET_MY_CUSTOMERS_REQUEST = `${prefix}GET_MY_CUSTOMERS_REQUEST`;
export const GET_MY_CUSTOMERS_RECEIVE = `${prefix}GET_MY_CUSTOMERS_RECEIVE`;
export const GET_MY_CUSTOMERS_ERROR = `${prefix}GET_MY_CUSTOMERS_ERROR`;
